module.exports = __webpack_public_path__ + "img/panking_3@3x.3fac4b9d.png";